import {
  LookupIcon,
  MapAreaIcon,
  SpinnerIcon,
  StorageIcon
} from "@/assets/icons";

import { IconText } from "../spatialAnalysis/projectList/projectCard";
import Divider from "../ui/Divider";

const TextSkeleton = ({ width = "w-full", height = "h-4" }) => (
  <div
    className={`${height} ${width} bg-whisper rounded animate-pulse`}
    data-testid="text-skeleton"
  />
);

const CardSkeleton = () => {
  return (
    <div className="py-2 px-1 overflow-hidden space-y-2">
      <TextSkeleton height="h-3" width="w-1/4" />
      <TextSkeleton height="h-3" width="w-full" />
      <div data-testid="card-divider">
        <Divider className="bg-white-smoke w-full h-[1px] my-2" />
      </div>
      <div className="flex gap-3 items-center">
        <IconText
          icon={<StorageIcon width={16} className="fill-purple-500" />}
          text={<TextSkeleton width="w-12" height="h-3" />}
        />
        <IconText
          icon={<MapAreaIcon width={16} />}
          text={<TextSkeleton width="w-16" height="h-3" />}
        />
        <IconText
          icon={<LookupIcon width={14} className="fill-teal-500" />}
          text={<TextSkeleton width="w-14" height="h-3" />}
        />
      </div>
    </div>
  );
};

interface LoadingShimmerProps {
  count?: number;
}

export const LoadingShimmer = ({ count = 2 }: LoadingShimmerProps) => {
  return (
    <div className="flex flex-col gap-2 py-2" data-testid="loading-shimmer">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index + 1}
          data-testid={`loading-card-skeleton-${index + 1}`}
          className="w-full text-left rounded-lg border border-gainsboro p-2"
        >
          <CardSkeleton />
        </div>
      ))}
      <div className="flex flex-col items-center mt-2 gap-2">
        <SpinnerIcon
          className="spin-animation"
          width={32}
          height={32}
          data-testid="loading-spinner"
        />
        <span
          className="text-txtPlaceholder text-xs"
          data-testid="loading-text"
        >
          Loading...
        </span>
      </div>
    </div>
  );
};
